var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"NavItemHot menu-item",class:[ {'on': _vm.NAV.TOPIC.id == _vm.navIndex} ]},[_c('a',{attrs:{"href":_vm.threeDLink,"target":"_blank"},on:{"click":function($event){_vm.listenStatistics(_vm.NAV.TOPIC.id),_vm.updateNavId(_vm.NAV.TOPIC.id)}}},[_vm._v("\n    精选专题\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }